import React from 'react';

// components
import MiniButton from '../../../components/elements/forms/MiniButton';
import TextInput from '../../../components/elements/forms/TextInput';

// state and service
import { update_result } from '../../../service/api/report_role';
import { IRoleCandidateUpdate } from '../../../store/types/report_role';
import { useAppDispatch } from '../../../store/hooks';

type IUpdatePros = {
	id: string;
	onRefresh: () => void;
	pros: string;
};

const UpdateResult: React.FC<IUpdatePros> = ({ id, pros, onRefresh }) => {
	const dispatch = useAppDispatch();
	const [show, showSet] = React.useState<boolean>(false);
	const [data, dataSet] = React.useState<IRoleCandidateUpdate>({
		id: '',
		name: ''
	});

	const onLoad = React.useCallback(() => {
		if (id) dataSet((prev) => ({ ...prev, id: id.toString(), name: pros }));
	}, [id, pros]);

	React.useEffect(() => {
		onLoad();
	}, [onLoad]);
	return (
		<div>
			{!show ? (
				<div>{data.name}</div>
			) : (
				<TextInput
					name="name"
					placeholder="Assessment Link"
					value={data.name}
					onChange={({ target }: React.ChangeEvent<HTMLInputElement>) => {
						dataSet((prev) => ({ ...prev, [target.name]: target.value }));
					}}
				/>
			)}
			<div className="w-full flex justify-end my-2">
				<div className="w-[15%]">
					<MiniButton
						title="Update"
						onHandler={() => {
							if (show) {
								// update new data
								update_result(dispatch, data);
								setTimeout(() => onRefresh(), 400);

								showSet(false);
							} else {
								showSet(true);
							}
						}}
						backgroundColor="#CDD8FE"
						textColor="#243677"
					/>
				</div>
			</div>
		</div>
	);
};

export default UpdateResult;
